import { numericKeys, actionsKeys } from '../../common/constants';

export const keyCodes = {
  // Numeric
  48: numericKeys.KEY_ZERO,
  49: numericKeys.KEY_ONE,
  50: numericKeys.KEY_TWO,
  51: numericKeys.KEY_THREE,
  52: numericKeys.KEY_FOUR,
  53: numericKeys.KEY_FIVE,
  54: numericKeys.KEY_SIX,
  55: numericKeys.KEY_SEVEN,
  56: numericKeys.KEY_EIGHT,
  57: numericKeys.KEY_NINE,
  // actions
  38: actionsKeys.KEY_UP,
  40: actionsKeys.KEY_DOWN,
  39: actionsKeys.KEY_RIGHT,
  37: actionsKeys.KEY_LEFT,
  13: actionsKeys.KEY_ENTER,
  403: actionsKeys.KEY_RED,
  404: actionsKeys.KEY_GREEN,
  405: actionsKeys.KEY_YELLOW,
  406: actionsKeys.KEY_BLUE,
  415: actionsKeys.KEY_PLAY,
  19: actionsKeys.KEY_PAUSE,
  413: actionsKeys.KEY_STOP,
  463: actionsKeys.KEY_PLAY_PAUSE,
  412: actionsKeys.KEY_REWIND,
  417: actionsKeys.KEY_FASTFORWARD,
  461: actionsKeys.KEY_BACK,
};

export const getKeymap = () => {};
